import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function Returned(props) {
  if (props.status === "Return") {
    return (
      <Svg
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Circle cx="4" cy="4" r="4" fill="#00AB59" />
      </Svg>
    );
  }
  return (
    <Svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M10.3333 1.6665C5.73333 1.6665 2 5.39984 2 9.99984C2 14.5998 5.73333 18.3332 10.3333 18.3332C14.9333 18.3332 18.6667 14.5998 18.6667 9.99984C18.6667 5.39984 14.9333 1.6665 10.3333 1.6665Z"
        fill="#00AB59"
      />
      <Path
        d="M15 13.7883C14.9203 13.9597 14.8124 14.0264 14.6764 13.9907C14.5615 13.9621 14.5005 13.8835 14.4747 13.7693C14.0948 12.1241 13.0654 11.1313 11.4732 10.7075C11.1707 10.6265 10.8588 10.5932 10.5446 10.5742C10.4836 10.5694 10.4789 10.5908 10.4789 10.6408C10.4812 11.0884 10.4812 11.536 10.4789 11.986C10.4789 12.1836 10.3452 12.305 10.167 12.2788C10.1201 12.2717 10.0779 12.2479 10.0404 12.2193C8.74127 11.2741 7.43512 10.3289 6.13132 9.38612C6.07269 9.34327 6.03986 9.28375 6 9.22661C6 9.17899 6 9.13137 6 9.08376C6.01407 8.99328 6.068 8.93376 6.1407 8.88139C7.27332 8.06238 8.40594 7.24337 9.53622 6.42436C9.69567 6.3077 9.85513 6.19342 10.0146 6.07914C10.1154 6.00771 10.2233 5.96724 10.3429 6.0339C10.4578 6.10056 10.507 6.20532 10.5047 6.33865C10.5023 6.76244 10.5047 7.18623 10.5047 7.6124C10.5047 7.71001 10.4859 7.73382 10.6172 7.75049C11.1824 7.82191 11.7217 7.98857 12.2306 8.24808C13.0701 8.67663 13.722 9.30756 14.1933 10.1289C14.4935 10.6551 14.6975 11.2194 14.8265 11.8098C14.8992 12.136 14.9531 12.4669 14.9789 12.8026C14.9883 12.9407 14.9836 13.0788 15 13.2169C15 13.4074 15 13.5978 15 13.7883Z"
        fill="white"
      />
    </Svg>
  );
}

export default Returned;
